import { render, staticRenderFns } from "./project_detail_m.vue?vue&type=template&id=4369217b&scoped=true&"
import script from "./project_detail_m.vue?vue&type=script&lang=js&"
export * from "./project_detail_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4369217b",
  null
  
)

export default component.exports